import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { computed } from 'vue';
import AppLink from './link.vue';
import { useRoute } from 'vue-router';
const __default__ = {
  name: 'MenuItem'
};
function setup(__props) {
  const props = __props;
  const route = useRoute();
  const isActive = computed(() => {
    return route.path === props.currentRoute.path || route.path === props.currentRoute.redirect || props.currentRoute.redirect && route.path.startsWith('/' + props.currentRoute.redirect.split('/')[1]);
  });
  return (_ctx, _cache) => {
    const _component_Ex_icon = _resolveComponent("Ex-icon");
    return __props.currentRoute.meta?.show ? (_openBlock(), _createBlock(AppLink, {
      key: 0,
      to: __props.currentRoute.path
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        class: _normalizeClass(["menu-item", {
          'sub-item': __props.currentRoute.meta?.isSubMenu,
          active: _unref(isActive),
          root: __props.layer === 0
        }]),
        style: _normalizeStyle({
          background: __props.currentRoute.meta?.isIcon ? '#f8f8f8' : ''
        })
      }, [_createElementVNode("div", {
        class: _normalizeClass({
          'menu-active': _unref(isActive) && !__props.currentRoute.meta?.isSubMenu
        }),
        onClick: _cache[0] || (_cache[0] =
        //@ts-ignore
        (...args) => _ctx.popShow && _ctx.popShow(...args))
      }, [_createVNode(_component_Ex_icon, {
        icon: __props.currentRoute.meta?.icon,
        size: 18,
        class: _normalizeClass({
          'sing-item': __props.currentRoute.meta?.singleMenu,
          active: _unref(isActive)
        })
      }, null, 8, ["icon", "class"]), _createElementVNode("span", {
        class: _normalizeClass(["menu-title", {
          'sing-item': __props.currentRoute.meta?.singleMenu,
          active: _unref(isActive)
        }])
      }, _toDisplayString(__props.currentRoute.meta?.title), 3)], 2)], 6)]),
      _: 1
    }, 8, ["to"])) : _createCommentVNode("", true);
  };
}
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    currentRoute: {
      type: null,
      required: true,
      default: {}
    },
    layer: {
      type: Number,
      required: true,
      default: 0
    }
  },
  setup
});